import { CalendarCheck, CalendarClock } from 'lucide-react'
import { BookingsSpaceFields } from '@/components/features/bookings/BookingsSpaceFields'
import {
  bookingsConfigApiErrors,
  defaultBookingsConfig,
  validateBookingsConfig
} from '@/components/features/bookings/bookingsConfig'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const BookingsPage = lazyPage(() => import('@/pages/Bookings'), 'BookingsPage')
const BookingResourcePage = lazyPage(() => import('@/pages/BookingResource'), 'BookingResourcePage')

export const bookingsModule: ModuleDefinition = {
  key: 'bookings',
  icon: CalendarClock,
  iconName: 'calendar-clock',
  namespaces: ['bookings'],
  ready: true,
  ListPage: BookingsPage,
  renderDetail: ({ spaceData }) => <BookingResourcePage spaceData={spaceData} />,
  /* The defaults every resource inherits have a body of their own (weekly hours): a third step (PADROES-UI section 14). */
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'bookings:config.stepLabel',
    stepHintKey: 'bookings:config.stepHint',
    defaultConfig: () => defaultBookingsConfig(),
    validate: (config, t) => validateBookingsConfig(config, t),
    errorsFromApi: (err) => bookingsConfigApiErrors(err),
    Fields: BookingsSpaceFields,
    persist: {
      type: 'moduleConfig',
      /* What this screen owns replaces its keys; anything else the space stored goes back untouched. */
      toModuleConfig: (config, stored) => ({
        ...(stored || {}),
        bookings: { ...(stored?.bookings || {}), ...config }
      }),
      fromSpace: (space) => ({ ...defaultBookingsConfig(), ...(space.moduleConfig?.bookings ?? {}) })
    }
  },
  workflow: { trigger: { block: 'bookings', icon: CalendarCheck, families: ['booking'] } }
}
